import { paths } from '../routes/paths';

import { CONFIG } from '../config-global';

import { SvgColor } from '../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name) => <SvgColor src={`${CONFIG.site.basePath}/assets/icons/navbar/${name}.svg`} />;

const ICONS = {
  user: icon('ic-user'),
  analytics: icon('ic-analytics'),
  chat: icon('ic-chat'),
};

// ----------------------------------------------------------------------

export const navData = [
  {
    subheader: 'Current',
    items: [
      { title: 'Account', path: paths.dashboard.account, icon: ICONS.user },
      { title: 'Chat', path: paths.dashboard.chat, icon: ICONS.chat },
      { title: 'Messages', path: paths.dashboard.messages, icon: ICONS.chat },
      {
        title: 'automations', path: paths.dashboard.automations.root, icon: ICONS.analytics, children: [
          { title: 'Create', path: paths.dashboard.automations.new },
          { title: 'List', path: paths.dashboard.automations.list },
        ],
      },
    ],
  }
];
